module.exports = __webpack_public_path__ + "static/media/Sahil Chopra.9d0ce4ed.png";